export default __webpack_public_path__ + "static/media/twan_transparent.e6e40956.png";